import { compose, resolveConstant } from './composer';

const assertHasServiceType = _ref => {
  let {
    serviceType
  } = _ref;

  if (serviceType) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['Service type is required']
  };
};

const assertHasMedicalAid = _ref2 => {
  let {
    hasMedicalAid
  } = _ref2;

  if (hasMedicalAid) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['Patient does not have medical aid']
  };
};

const assertHasMedicalAidAuthorization = _ref3 => {
  let {
    hasMedicalAidAuthorization
  } = _ref3;

  if (hasMedicalAidAuthorization) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['Patient does not have medical aid authorization']
  };
};

const defaultCanRequestPathologyRules = [assertHasServiceType, assertHasMedicalAid, assertHasMedicalAidAuthorization];
const encounterServiceRules = {
  'encounter.service.tcp': [assertHasMedicalAid]
};
/**
 * a function that takes in a set of parameters and based on that determines if a consumer can do a pathology request for the patient
 */

export const validatePathologyRequest = compose({
  getRuleName: _ref4 => {
    let {
      serviceType
    } = _ref4;
    return serviceType || 'no-service-type';
  },
  assertions: encounterServiceRules,
  defaultAssertions: defaultCanRequestPathologyRules,
  defaultResolver: resolveConstant(true)
});
//# sourceMappingURL=pathology.js.map